import * as React from "react";
const SvgBlackFlag = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#1d1f20", d: "M2.5 10.501c4-3 7 3 11 0v-7.5c-4 3-7-3-11 0", style: {
  fill: "#1d1f20",
  fill: "color(display-p3 .1146 .1208 .1239)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#a0a7ab", strokeLinecap: "round", strokeLinejoin: "round", d: "M2.5 13.501v-10.5", style: {
  stroke: "#a0a7ab",
  stroke: "color(display-p3 .6275 .6549 .6706)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", d: "m7.293 5.776 1.414 2.45m.518-1.932-2.45 1.414", style: {
  stroke: "#fff",
  strokeOpacity: 1
} }));
export default SvgBlackFlag;
